export default "__VITE_ASSET__743dd19f__"